import { useEffect, useState } from "react";
import { Plus, Trash2, Edit2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

const empty = { code: "", type: "percent", value: 10, active: true };

export default function Promotions() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [announcement, setAnnouncement] = useState({ announcement_text: "", announcement_active: true });

  const load = () => api.get("/admin/coupons").then((r) => setItems(r.data.coupons));
  const loadSettings = () => api.get("/admin/settings").then((r) => setAnnouncement({ announcement_text: r.data.announcement_text || "", announcement_active: !!r.data.announcement_active }));
  useEffect(() => { load(); loadSettings(); }, []);

  const save = async () => {
    try {
      if (editing) await api.put(`/admin/coupons/${editing}`, { ...form, value: parseFloat(form.value) });
      else await api.post("/admin/coupons", { ...form, value: parseFloat(form.value) });
      toast.success(editing ? "Updated" : "Created");
      setEditing(null); setForm(empty); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete coupon?")) return; await api.delete(`/admin/coupons/${id}`); load(); };
  const edit = (c) => { setEditing(c.id); setForm({ code: c.code, type: c.type, value: c.value, active: c.active }); };

  const saveAnnouncement = async () => {
    await api.put("/admin/settings", announcement);
    toast.success("Announcement saved");
  };

  return (
    <div data-testid="admin-promotions-page">
      <div className="font-mono text-xs uppercase tracking-widest text-[#00FF66]">// promotions</div>
      <h1 className="font-heading font-bold text-3xl mt-1 mb-8">Coupons & banner</h1>

      <div className="surface p-6 mb-8">
        <h3 className="font-heading font-semibold mb-3">Top banner</h3>
        <input data-testid="banner-text" value={announcement.announcement_text} onChange={(e) => setAnnouncement({ ...announcement, announcement_text: e.target.value })} className="input-term" placeholder="e.g. Free worldwide delivery" />
        <label className="flex items-center gap-2 mt-3 font-mono text-sm">
          <input type="checkbox" checked={announcement.announcement_active} onChange={(e) => setAnnouncement({ ...announcement, announcement_active: e.target.checked })} className="accent-[#00FF66]" />
          show banner
        </label>
        <button onClick={saveAnnouncement} className="btn-primary mt-4" data-testid="save-banner-btn">save banner</button>
      </div>

      <div className="surface p-6 mb-8">
        <h3 className="font-heading font-semibold mb-4">{editing ? "Edit coupon" : "New coupon"}</h3>
        <div className="grid md:grid-cols-4 gap-3">
          <input data-testid="coupon-code-input" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} className="input-term" placeholder="WELCOME10" />
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="input-term">
            <option value="percent">percent (%)</option>
            <option value="fixed">fixed ($)</option>
          </select>
          <input type="number" step="0.01" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} className="input-term" placeholder="10" />
          <select value={form.active ? "1" : "0"} onChange={(e) => setForm({ ...form, active: e.target.value === "1" })} className="input-term">
            <option value="1">active</option><option value="0">inactive</option>
          </select>
        </div>
        <div className="mt-4 flex gap-2">
          <button onClick={save} className="btn-primary" data-testid="save-coupon-btn"><Plus className="w-4 h-4" />{editing ? "update" : "create"}</button>
          {editing && <button onClick={() => { setEditing(null); setForm(empty); }} className="btn-ghost">cancel</button>}
        </div>
      </div>

      <div className="surface overflow-x-auto">
        <table className="w-full text-sm min-w-[600px]">
          <thead>
            <tr className="border-b border-[#1E293B] font-mono text-[11px] uppercase tracking-widest text-[#71717A]">
              <th className="text-left p-3">Code</th><th className="text-left p-3">Type</th><th className="text-right p-3">Value</th><th className="text-left p-3">Status</th><th className="text-right p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan="5" className="p-6 text-center text-[#A1A1AA] font-mono">no coupons</td></tr>}
            {items.map((c) => (
              <tr key={c.id} className="border-b border-[#1E293B] last:border-0">
                <td className="p-3 font-mono text-[#00FF66]">{c.code}</td>
                <td className="p-3 font-mono text-xs">{c.type}</td>
                <td className="p-3 text-right font-mono">{c.type === "percent" ? `${c.value}%` : `$${c.value}`}</td>
                <td className="p-3"><span className={`chip-mono ${!c.active ? "!bg-white/5 !text-[#A1A1AA] !border-white/10" : ""}`}>{c.active ? "active" : "inactive"}</span></td>
                <td className="p-3 text-right">
                  <div className="inline-flex gap-2">
                    <button onClick={() => edit(c)} className="btn-ghost !py-1 !px-2"><Edit2 className="w-3.5 h-3.5" /></button>
                    <button onClick={() => del(c.id)} className="btn-ghost !py-1 !px-2 hover:!border-[#FF3B30] hover:!text-[#FF3B30]"><Trash2 className="w-3.5 h-3.5" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
